import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 週別部門別供給高GP予算進捗を出力するサービス
 *
 * @export OutputGBBudgetProgressFileService
 * @class OutputGBBudgetProgressFileService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputGPBudgetProgressFileService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private successFunc: Function;
  vo = {
    orderCodeFrom: '',
    orderCodeTo: ''
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputGBBudgetProgressFileService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCodeFrom: this.vo.orderCodeFrom,
        OrderCodeTo: this.vo.orderCodeTo
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof OutputGBBudgetProgressFileService
   */
  execute(vo, successFunc: Function) {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('outputGPBudgetProgressFile', this.getBody());
  }

  /**
 * API通信成功時の処理
 *
 * @param {*} data レスポンスデータ
 * @memberof OutputGBBudgetProgressFileService
 */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
